(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wotobeus-community"] && !Shopify.designMode) return;
  try {
    
class WotobeusCommunity extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.cards = [...this.querySelectorAll('[data-card]')];
    this.pool = [...this.querySelectorAll('[data-review]')];
    this.dialog = this.querySelector('dialog');
    this.pauseButton = this.querySelector('[data-pause]');
    this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.pauseButton.setAttribute('aria-pressed', String(this.paused));
    this.next = this.cards.length;
    this.slot = 0;
    this.pauseButton.addEventListener('click', () => {
      this.paused = !this.paused;
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
    }, {signal});
    this.cards.forEach(card => card.addEventListener('click', () => {
      const detail = this.querySelector('[data-detail]');
      detail.replaceChildren(this.pool[Number(card.dataset.index)].content.cloneNode(true));
      this.dialog.showModal();
    }, {signal}));
    this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), {signal});
    this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, {signal});
    if (this.pool.length > this.cards.length) this.timer = setInterval(() => this.rotate(), 2600);
  }
  disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); clearTimeout(this.swapTimer); }
  rotate() {
    if (this.paused || document.hidden || this.dialog.open || this.matches(':hover') || this.contains(document.activeElement)) return;
    const shown = new Set(this.cards.map(card => Number(card.dataset.index)));
    let next = this.next % this.pool.length;
    while (shown.has(next)) next = (next + 1) % this.pool.length;
    const card = this.cards[this.slot % this.cards.length];
    card.classList.add('is-fading');
    this.swapTimer = setTimeout(() => {
      if (!this.isConnected) return;
      card.replaceChildren(this.pool[next].content.cloneNode(true));
      card.dataset.index = String(next);
      card.classList.remove('is-fading');
      this.next = next + 1;
      this.slot++;
    }, 460);
  }
}
if (!customElements.get('wotobeus-community')) customElements.define('wotobeus-community', WotobeusCommunity);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wotobeus-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wotobeus-comparison')){
customElements.define('wotobeus-comparison',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;
  const input=this.querySelector('input');
  input.addEventListener('input',()=>{this.style.setProperty('--reveal',input.value+'%');input.setAttribute('aria-valuetext',input.value+'%')});
 }
});
}

  } catch(e) { console.error(e); }
})();
})();
